import { Component, OnInit, Inject, ViewChild, ElementRef } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { CommonService } from "../../_services/common.service";
import {
  FormBuilder,
  FormGroup,
  Validators,
  FormArray,
  FormControl
} from "@angular/forms";
import { Observable } from 'rxjs';
import { map, startWith } from 'rxjs/operators';
import { FlashMessagesService } from "angular2-flash-messages";


export interface DialogData {
  order_id: string;
  client_phone: string;
}

@Component({
  selector: 'app-sms-public-url',
  templateUrl: './sms-public-url.component.html',
  styleUrls: ['./sms-public-url.component.css']
})
export class SmsPublicUrlComponent implements OnInit {
    @ViewChild('msg') msg: ElementRef;
    public loading = false;
    smsPublicUrl: FormGroup;
    isActive = 'no';
    userList: Array<any> = [];
    searchTextboxControl = new FormControl();
    filteredOptions: Observable<any[]>;
    public isShowError = false;  
    characterCount: number = 0;
    public smsTags: Array<any> = [
      { value: "", viewValue: "Select Tag add in sms message" },
      { value: "{{order_url}}", viewValue: "Order URL" },
      { value: "{{site_title}}", viewValue: "Site Title" },
      { value: "{{site_url}}", viewValue: "Site Url" },
      { value: "{{site_address1}}", viewValue: "Site Address1" },
      { value: "{{site_address2}}", viewValue: "Site Address2" },
      { value: "{{site_city}}", viewValue: "Site City" },
      { value: "{{site_state}}", viewValue: "Site State" },
      { value: "{{site_zip}}", viewValue: "Site Zip" },
      { value: "{{site_email}}", viewValue: "Site Email" },
      { value: "{{site_phone}}", viewValue: "Site Phone" },
      { value: "{{site_facebook_url}}", viewValue: "Site Facebook URL" },
      { value: "{{site_twitter_url}}", viewValue: "Site Twitter URL" },
      { value: "{{site_instagram_url}}", viewValue: "Site Instagram URL" },
      { value: "{{site_pinterest_url}}", viewValue: "Site Pinterest URL" },
      { value: "{{site_gplus_url}}", viewValue: "Site Gplus URL" },
      { value: "{{site_linkedin_url}}", viewValue: "Site Linkedin URL" },
      { value: "{{site_vimeo_url}}", viewValue: "Site Vimeo URL" },
      { value: "{{site_youtube_url}}", viewValue: "Site Youtube URL" },
      { value: "{{order_id}}", viewValue: "Order Id" },
      { value: "{{total_projects}}", viewValue: "Total Projects" },
      { value: "{{total_quantity}}", viewValue: "Total Quantity" },
      { value: "{{total_price}}", viewValue: "Total Price" },
      { value: "{{total_custom_items_price}}", viewValue: "Total Custom Items Price" },
      { value: "{{shipping_price}}", viewValue: "Shipping Price" },
      { value: "{{turn_around_time_price}}", viewValue: "Turn Around Time Price" },
      { value: "{{Discount}}", viewValue: "Discount" },
      { value: "{{discount_percentage}}", viewValue: "Discount Percentage" },
      { value: "{{tax}}", viewValue: "Tax" },
      { value: "{{tax_percentage}}", viewValue: "Tax Percentage" },
      { value: "{{grand_total_price}}", viewValue: "Grand Total Price" },
      { value: "{{paid_amount}}", viewValue: "Paid Amount" },
      { value: "{{balance_amount}}", viewValue: "Balance Amount" },
      { value: "{{refunded_amount}}", viewValue: "Refunded Amount" },
      { value: "{{net_days}}", viewValue: "Net Days" },
      { value: "{{po_number}}", viewValue: "PO Number" },
      { value: "{{delivery_days}}", viewValue: "Delivery Days" },
      { value: "{{delivery_date}}", viewValue: "Delivery Date" },
      { value: "{{order_date}}", viewValue: "Order Date" },
      { value: "{{shipping_method}}", viewValue: "Shipping Method" },
      { value: "{{turn_around_times}}", viewValue: "Turn Around Times" },
      { value: "{{status}}", viewValue: "Status" },
      { value: "{{company_name}}", viewValue: "Company Name" },
      { value: "{{first_name}}", viewValue: "First Name" },
      { value: "{{middle_name}}", viewValue: "Middle Name" },
      { value: "{{last_name}}", viewValue: "Last Name" },
      { value: "{{full_name}}", viewValue: "Full Name" },
      { value: "{{email}}", viewValue: "Email" },
      { value: "{{phone}}", viewValue: "Phone" },
      { value: "{{username}}", viewValue: "Username" },
      { value: "{{customer_first_name}}", viewValue: "Customer First Name" },
      { value: "{{customer_last_name}}", viewValue: "Customer Last Name" },
      { value: "{{customer_company_name}}", viewValue: "Customer Company Name" }
    ];
    public selectedSmsTags = "";
    public defaultMessage = 'Click the button: {{order_url}}';
  
    constructor(private formBuilder: FormBuilder,
      public dialogRef: MatDialogRef<SmsPublicUrlComponent>,
      private CommonService: CommonService,
      private _flashMessagesService: FlashMessagesService,
      @Inject(MAT_DIALOG_DATA) public data: DialogData) { }
  
    ngOnInit() { 
      this.filteredOptions = this.searchTextboxControl.valueChanges
        .pipe(
          startWith<string>(''),
          map(name => this._filter(name))
        );
  
      this.smsPublicUrl = this.formBuilder.group({
        phoneNumber: [null, [Validators.required]],
        message: [this.defaultMessage, Validators.required],
        orderId: [null]
      });
      if (this.data.order_id == '') {
        const orderIdControl = this.smsPublicUrl.get('orderId');
        orderIdControl.setValidators([Validators.required]);
      }
      if (this.data.client_phone) {
          this.isActive = 'yes';
          this.smsPublicUrl.patchValue({
          'phoneNumber': this.data.client_phone
        });
      }

      this.getDefaultTemplate();
    }
    isFieldValid(field: string) {
      return (
        !this.smsPublicUrl.get(field).valid &&
        this.smsPublicUrl.get(field).touched
      );
    }
    onSubmit(postData) {
      this.dialogRef.close(postData);
    }
  
    onNoClick(): void {
      this.dialogRef.close();
    }
  
    private _filter(name: string): Array<any> {
      const filterValue = name.toLowerCase();
      let filteredList = this.getClientList(filterValue);
      return filteredList;
    }
  
    clearSearch(event) {
      event.stopPropagation();
      this.searchTextboxControl.patchValue('');
    }
  
    getClientList = function (searchText) {
      this.customeItemOptions = {
        id: localStorage.getItem("userID"),
        search: searchText
      };
  
      this.CommonService.apiService(
        "POST",
        "users/list",
        this.customeItemOptions
      ).subscribe(
        (response: any) => {
          this.loading = false;
          if (response.status === true) {
            if (response.data) {
              this.userList = response.data.records;
            }
          }
        },
        err => {
          this.loading = false;
          console.log(err);
        }
      );
      return this.userList;
    }
  
    getSelectedValue(clientName) {
      let previousPhoneNumber = this.smsPublicUrl.get('phoneNumber').value ? this.smsPublicUrl.get('phoneNumber').value : '';
      let clientData = this.userList.find(x => x.name === clientName);
      if (clientData && clientData.phone) {
        this.isActive = 'yes';
        if (previousPhoneNumber != '') {
          previousPhoneNumber = previousPhoneNumber + ',' + clientData.phone;
        }
        else {
          previousPhoneNumber = clientData.phone;
        }
      }
      this.smsPublicUrl.get('phoneNumber').patchValue(previousPhoneNumber);
    }
  
    trackByFn(index: any, item: any) {
      return index;
    }
  
    sendPublicUrlSms = function (postData) {
      this.loading = true;
      let phoneNumberArr = postData.phoneNumber.split(',');
      let smsOption = {
        id: localStorage.getItem("userID"),
        order_id: this.data.order_id,
        message: postData.message,
        phone_numbers: phoneNumberArr
      };
      if (this.data.order_id == '') {
        smsOption.order_id = postData.orderId;
      }
      
      this.CommonService.apiService(
        "POST",
        "order/public/url/sms",
        smsOption
      ).subscribe(
        (response: any) => {
          this.loading = false;
          if (response.status === true) {
            this._flashMessagesService.show(response.message, {
              cssClass: "alert-success",
              timeout: 2000
            });
            setTimeout(() => {
              this.dialogRef.close();
            }, 2500);
          }
        },
        err => {
          this.loading = false;
          this._flashMessagesService.show(err.error.message, {
            cssClass: "alert-warning",
            timeout: 5000
          });
        }
      );
    }
  
    onSmsTagChange(phoneTagValue) {
      if (phoneTagValue != '') {
        let startPos = this.msg.nativeElement.selectionStart;
        this.msg.nativeElement.focus();
        this.smsPublicUrl.get('message').patchValue(this.msg.nativeElement.value.substr(0, this.msg.nativeElement.selectionStart) + phoneTagValue + this.msg.nativeElement.value.substr(this.msg.nativeElement.selectionStart, this.msg.nativeElement.value.length));
        this.msg.nativeElement.selectionStart = startPos;
        this.msg.nativeElement.focus();
      }
  
    }

    updateCharacterCount(value: string) {
      this.characterCount = value.length;
    }

    getDefaultTemplate = function () {
      const postData = {
        id: localStorage.getItem("userID"),
      };
  
      this.CommonService.apiService(
        "POST",
        "options/getDefaultTemplate",
        postData
      ).subscribe(
        (response: any) => {
          this.loading = false;
          if (response.status === true) {
            if (response.data) {
              this.templateData = response.data;
              if (this.templateData) {
                const messageFromTemplate = this.templateData.sms_default_sms_template_message;
                const turnOffSMS = this.templateData.sms_default_sms_template_turn_off_sms;
              
                if (messageFromTemplate && turnOffSMS === '0') {
                  this.smsPublicUrl.get('message').setValue(messageFromTemplate);
                } else {
                  this.smsPublicUrl.get('message').setValue(this.defaultMessage);
                }
              }
            }
          }
        },
        err => {
          console.log(err);
        }
      );
    }
}



// WEBPACK FOOTER //
// /var/www/login.theprintlife.com/src/app/mnt-invoices/sms-public-url/sms-public-url.component.ts